export default __webpack_public_path__ + "static/media/partner_logo_ruter.ca73ebf5.svg";